import NewPurchaseInvoice from "../../../../components/@documents/purchase_invoices/NewPurchaseInvoice";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseInvoiceNewPage() {

    return (
        <NewPurchaseInvoice 
            routeType={routeTypes.admin}
        />
    )
}